import VoiceMode from './VoiceMode'

export default VoiceMode
// eslint-disable-next-line import/export
export * from './VoiceMode'
